import { createRESTStore } from "@stores/shared/createRESTStore";
import API from "@config/shared/api-paths";

const useZonesStore = createRESTStore({
  entityName: "zones",
  apiPaths: {
    fetch: API.BASE + API.FRONTEND.ZONES,
  },
  initialState: [],
  processResponse: {
    fetch: (response) => response.items,
  },
});

export default useZonesStore;
